import EntryVariant from "panels/bundleEntries/entities/EntryVariants";

const CartItemDetails = (props) => {
	const courseWithPrice = [];
	let totalPrice = 0;
	const entryVariantDetails = [];
	const { variantIds, entryIds } = props.cartItems.reduce(
		(acc, item) => {
			const match = props.quantityInCart.find(
				({ courseId }) => courseId === item.id
			);
			const courseQuantity = match ? match.courseQuantity : 0;

			item.variants.forEach((variant) => {
				acc.variantIds.push(variant.id);
				acc.entryIds.push(item.id);

				const price = courseQuantity * variant.price;
				courseWithPrice.push({
					name: item.title,
					price,
				});
				// Adding new entry with entryId, entryVariantId, and courseQuantity
				entryVariantDetails.push({
					entryId: item.id,
					entryVarId: variant.id,
					quantity: courseQuantity,
				});
				totalPrice += price;
			});

			return acc;
		},
		{ variantIds: [], entryIds: [] }
	);

	return {
		variantIds,
		entryIds,
		totalPrice,
		courseWithPrice,
		entryVariantDetails,
	};
};

export default CartItemDetails;



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/utils/CartItemDetails.ts